import { Component, OnInit, inject } from '@angular/core';
import { Background } from '../../shared/components/background/background';
import { HeroSection } from '../../shared/components/hero-section/hero-section';
import { Connect } from '../../shared/components/connect/connect';
import { TeamCardContainer } from './components/team-card-container/team-card-container';
import { SeoService } from '../../shared/services/seo.service';

@Component({
  selector: 'app-team',
  imports: [Background, HeroSection, Connect, TeamCardContainer],
  templateUrl: './team.html',
  styleUrl: './team.scss'
})
export class Team implements OnInit {

  protected file = 'team';

  private seo = inject(SeoService);

  ngOnInit() {
    this.seo.apply({
      title: 'About Us',
      description: 'Meet the SEM Nexus team — founders, engineers, and growth marketers who build and scale mobile apps for B2B and B2C clients.',
      canonical: '/team/',
      image: 'https://semnexus.com/images/team/backgrounds/team.avif',
      imageAlt: 'SEM Nexus team',
      type: 'website',
    });
    this.seo.setBreadcrumbs([
      { name: 'Home', url: '/' },
      { name: 'About Us' },
    ]);
  }
}
